import axios, { AxiosInstance, AxiosResponse } from 'axios';

export interface WhatsappAutomationRule {
  id: string;
  cnpj: string;
  event: string;
  statusFilter?: string;
  active: boolean;
  templateId?: string;
  templateBody?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateWhatsappAutomationRuleRequest {
  statusFilter?: string;
  templateId?: string;
  templateBody?: string;
  active?: boolean;
}

export interface UpdateWhatsappAutomationRuleRequest {
  statusFilter?: string | null;
  templateId?: string | null;
  templateBody?: string | null;
  active?: boolean;
}

class WhatsappAutomationService {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
      timeout: 10000,
    });

    this.client.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  async listRules(): Promise<WhatsappAutomationRule[]> {
    try {
      const response: AxiosResponse<WhatsappAutomationRule[]> = await this.client.get(
        '/admin/whatsapp-automation/rules'
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao listar regras de automação de WhatsApp');
    }
  }

  async createRule(data: CreateWhatsappAutomationRuleRequest): Promise<WhatsappAutomationRule> {
    try {
      const response: AxiosResponse<WhatsappAutomationRule> = await this.client.post(
        '/admin/whatsapp-automation/rules',
        data
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao criar regra de automação de WhatsApp');
    }
  }

  async updateRule(id: string, data: UpdateWhatsappAutomationRuleRequest): Promise<WhatsappAutomationRule> {
    try {
      const response: AxiosResponse<WhatsappAutomationRule> = await this.client.put(
        `/admin/whatsapp-automation/rules/${id}`,
        data
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao atualizar regra de automação de WhatsApp');
    }
  }
}

export const whatsappAutomationService = new WhatsappAutomationService();
export default whatsappAutomationService;
